import { boolean, object, string } from 'yup';

import { LoginRequestInterface } from '@interface/auth/login.interface';
import { getFormValidator } from '@util/form/get-form-validator';

export const loginFormValidation = getFormValidator(
  object<LoginRequestInterface>().shape({
    email: string().email(),
    password: string(),
    remember: boolean(),
  }),
);
